<template>
  <b-overlay :show="loadingFile" class="row view-panel" v-bind:class="{'toggle': toggle}">
    <div class="col-md-12 button-panel">
      <div class="d-flex justify-end">
        <b-button
          v-show="activeElement && activeElement.type === 'file' && isGore"
          v-tooltip="'Seleccionar documento'"
          data-cy="select-document"
          class="badge-glow mr-2"
          variant="warning"
          size="sm"
          @click="selectToDoc(false)"
          :disabled="userPermissions.read === 0 ||
          files.length >= maxFiles"
        >
          <feather-icon
            icon="CheckIcon"
            size="16"
          />
          Seleccionar
        </b-button>
        <b-button
          v-if="showPrincipalButton"
          v-show="activeElement && activeElement.type === 'file' && isGore"
          v-tooltip="'Seleccionar documento como archivo principal'"
          data-cy="select-main-document"
          class="badge-glow"
          variant="warning"
          size="sm"
          @click="selectToDoc(true)"
          :disabled="userPermissions.read === 0"
        >
          <feather-icon
            icon="CheckIcon"
            size="16"
          />
          Seleccionar como principal
        </b-button>
      </div>
    </div>
    <!-- NAVEGADOR DE DIRECTORIOS Y DOCUMENTOS -->
    <div class="col-md-12">
      <div
        class="mt-4 wrap-table shadow bg-white rounded overflow-y-scroll view-table"
      >
        <table class="w-100 rounded" >
          <thead class="fb-bg-primary" style="color:white;">
            <tr>
              <th>
                Estado
              </th>
              <th>
                Nombre
              </th>
              <th class="text-center">
                Tamaño
              </th>
              <th>
                Fecha Creación
              </th>
              <th>
                Propietario
              </th>

            </tr>
          </thead>
          <tbody id="folder-elements">
            <!-- FOLDER ELEMENTS -->
            <MinimalNavigationElement
              v-for="element in folderElements"
              :element="element" :key="element.id"
              data-cy="folder"
            />
            <!-- FILE ELEMENTS -->
            <MinimalNavigationElement
              v-for="element in fileElements"
              :element="element" :key="element.id"
              data-cy="file"
            />
            <!-- EMPTY FOLDER MESSAGE -->
            <tr v-if="isEmptyFolder">
              <td colspan="5">
                <div class="d-flex justify-center m-5">
                  <span>Ups! esta carpeta esta vacía.</span>
                </div>
              </td>
            </tr>
          </tbody>
          <!-- SKELETON LOADER -->
          <tr v-show="loadingElements">
            <td class="pl-5 pt-2">
                <b-skeleton  class="bg-grey-light w-50" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
                <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
          </tr>
          <tr v-show="loadingElements">
            <td class="pl-5 pt-2">
                <b-skeleton  class="bg-grey-light w-50" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
                <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
            <td class="pl-5 pt-2">
              <b-skeleton class="bg-grey-light w-100" animation="fade"/>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <FileFormView v-if="modalName" :isEdit="isEdit" />
    <FolderFormView v-if="modalName" :isEdit="isEdit" />
    <!-- <NewCustomDocument v-if="modalName" /> -->
    <WizardDocumentosPersonalizados v-if="modalName" />
  </b-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFolder, faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons';

import {
  ioGetPrivateUploadUrl,
  ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';
import FileFormView from '@/febos/global/documentManagement/vistas/modals/FileFormView';
import NewCustomDocument from '@/febos/global/documentManagement/vistas/modals/NewCustomDocument';
import WizardDocumentosPersonalizados from '@/febos/global/documentManagement/vistas/modals/wizard/WizardDocumentosPersonalizados';
import FolderFormView from '@/febos/global/documentManagement/vistas/modals/FolderFormView';
import MinimalNavigationElement
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalNavigationElement';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import PublicationStateTypes from '@/febos/global/documentManagement/mixins/PublicationStateTypes';
import ValidityStateTypes from '@/febos/global/documentManagement/mixins/ValidityStateTypes';
import { ioEDFilesGet } from '@/febos/servicios/api/repositories.api';

library.add(faFolder, faArrowAltCircleDown);
export default {
  name: 'navigation-panel',
  components: {
    FileFormView,
    FolderFormView,
    MinimalNavigationElement,
    NewCustomDocument,
    WizardDocumentosPersonalizados
  },
  props: {
    showPrincipalButton: {
      type: Boolean,
      default: false
    },
    toggle: Boolean,
    addFile: {
      type: Function
    },
    removeFile: {
      type: Function
    },
    files: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      loadingFile: false,
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
      folderElements: [],
      fileElements: [],
      selectedElement: {},
      activeElement: null,
      isEdit: false,
      filesToUpload: [],
      dragging: false,
      individualProgress: {},
      progress: 0,
      approvalStateTypes: ApprovalStateTypes,
      publicationStateTypes: PublicationStateTypes,
      validityStateTypes: ValidityStateTypes
    };
  },
  methods: {
    ...mapActions('DocManagement', [
      'removeFolder',
      'uploadFile'
    ]),
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Dnts', [
      'createDnt'
    ]),
    createFileEd(category) {
      console.log('se crea el borrador del expediente', category);
    },
    async selectToDoc(principal = false) {
      if (this.activeElement.type === 'file') {
        this.loadingFile = true;
        let fileInfo = await ioEDFilesGet({
          repositoryId: 0,
          fileId: this.activeElement.id
        });
        this.loadingFile = false;
        const selectedFile = {
          id: fileInfo.data.archivo.archivoId,
          archivoId: fileInfo.data.archivo.archivoId,
          name: fileInfo.data.archivo.nombre,
          source: 'repositorio',
          origen: 'repositorio',
          tipo: 'repositorio',
          currentDescription: fileInfo.data.archivo.nombre,
          mime: fileInfo.data.archivo.mime,
          date: fileInfo.data.archivo.fechaCreacion,
          path: fileInfo.data.archivo.adjuntoUrl,
          failed: false,
          principal
        };
        this.addFile(selectedFile);
        fileInfo = {};
      }
    },
    openElement() {
      window.open(this.activeElement.downloadURL);
    },
    onChange() {
      this.filesToUpload = [...this.$refs.file.files];
    },
    async uploadFileToS3(file, url) {
      try {
        const response = await ioGetPrivateUploadUrl(url, file.type);
        const that = this;
        await ioUploadFileToPrivateUrl(
          response.data?.url,
          file,
          (percent) => {
            const unique = file.name + file.lastModified;
            that.individualProgress[unique] = percent;
            that.updateProgress();
          }
        );
        this.uploadFile({
          repositoryId: this.repositoryId,
          folderId: this.getSelectedFolderId,
          file: {
            carpetaId: this.getSelectedFolderId,
            nombre: file.name,
            urlTransito: url,
            esPublico: 'N',
            idioma: 'es',
            versionExterna: '',
            estadoVigencia: this.validityStateTypes.NOT_APPLY,
            estadoAprobacion: this.approvalStateTypes.NOT_APPLY,
            estadoPublicacion: this.publicationStateTypes.DRAFT
          }
        });
      } catch (e) {
        console.error(e);
      }
      return url;
    },
    updateProgress() {
      const sumProgress = Object.values(this.individualProgress).reduce((t, n) => t + n);
      if (sumProgress === 0) this.progress = 0;
      const current = sumProgress * 100;
      const max = this.filesToUpload.length * 100;
      this.progress = Math.round(current / max);
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'companyId', 'iut', 'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getFilesStack',
      'getRepositories',
      'loadingElements',
      'loading',
      'getPermissionsStack'
    ]),
    canSelectDraft() {
      const { params } = this.$route;
      if (params.view && params.view.includes('pendientes')) {
        const extension = this.activeElement.name.split('.').pop().toLowerCase();
        if (this.activeElement.publicationState === this.publicationStateTypes.DRAFT) {
          if (!['doc', 'docx'].includes(extension)) {
            return false;
          }
        } else {
          return true;
        }
      }
      return true;
    },
    isGore() {
      return this.company.iut === '72235100-2';
    },
    showDrangAndDropUploader() {
      return this.dragging || this.filesToUpload.size > 0;
    },
    repositoryId() {
      let response = '';
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].repositoryId;
      }
      if (this.getSelectedRepositoryId) {
        response = this.getSelectedRepositoryId;
      }
      return response;
    },
    elementName() {
      let response = '';
      if (this.getSelectedRepositoryId) {
        response = this.getRepositories[this.getSelectedRepositoryId].nombreRepositorio;
      }
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].nombre;
      }
      return response;
    },
    isEmptyFolder() {
      if (!this.loading && !this.folderElements.length && !this.fileElements.length) {
        return true;
      }
      return false;
    }
  },
  watch: {
    getSelectedElement() {
      const selectedElement = this.getSelectedElement || {};
      this.activeElement = this.getSelectedElement || {};
      this.userPermissions.read = selectedElement.loggedUserPermissions?.lectura;
      this.userPermissions.write = selectedElement.loggedUserPermissions?.escritura;
      this.userPermissions.totalControl = selectedElement.loggedUserPermissions?.controlTotal;
    },
    getTreeElements() {
      this.folderElements = [];
      let folders = {};
      if (this.getSelectedRepositoryId) {
        folders = Object.values(this.getTreeElements)
          .filter((element) => (
            element.parentFolder === null && element.repositoryId === this.getSelectedRepositoryId
          ));
      }
      if (this.getSelectedFolderId) {
        folders = Object.values(this.getTreeElements)
          .filter((element) => (
            element.parentFolder === this.getSelectedFolderId
          ));
      }
      this.folderElements = folders.map((folder) => ({
        id: folder.carpetaId,
        name: folder.nombre,
        fullpathId: folder.fullpathId,
        parentFolder: folder.parentFolder,
        repositoryId: folder.repositoryId,
        creationDate: folder.fechaCreacion,
        ownerId: folder.propietario.id,
        owner: folder.propietario.alias,
        numberOfFiles: folder.cantidadArchivos,
        numberOfFolders: folder.cantidadCarpetas,
        tags: [],
        keywords: [],
        type: 'folder'
      }));
    },
    getFilesStack() {
      this.fileElements = [];
      let files = [];
      if (this.getSelectedRepositoryId) {
        files = Object.values(this.getFilesStack)
          .filter((element) => (
            element.parentFolder === null && element.repositoryId === this.getSelectedRepositoryId
          ));
      }
      if (this.getSelectedFolderId) {
        files = Object.values(this.getFilesStack)
          .filter((element) => (
            element.parentFolder === this.getSelectedFolderId
          ));
      }
      this.fileElements = files.map((file) => ({
        id: file.archivoId,
        name: file.nombre,
        codeType: file.codType,
        creationDate: file.fechaCreacion,
        publicationDate: file.fechaPublicacion,
        parentFolder: file.parentFolder,
        ownerId: file.propietario.id,
        owner: file.propietario.alias,
        size: file.pesoArchivo,
        mimeFile: file.mime,
        type: 'file',
        documentId: file.documentoId,
        repositoryId: file.repositoryId,
        urlFile: file.urlAdjunto,
        downloadURL: `${file.urlDescarga}?t=${this.currentUser.token}&e=${this.companyId}`,
        publicLink: file.esPublico === 'S' ? file.urlDescarga : undefined,
        isPublic: file.esPublico === 'S',
        externalVersion: file.versionExterna,
        publicationState: file.estadoPublicacion,
        validityState: file.estadoVigencia,
        approvalState: file.estadoAprobacion,
        expirationDate: file.fechaVencimiento,
        expirationType: file.tipoExpiracion
      }));
    },
    getSelectedFolderId() {
      this.folderElements = [];
      this.fileElements = [];
      if (this.getSelectedFolderId) {
        this.selectedElement = this.getTreeElements[this.getSelectedFolderId];
      }
    },
    getSelectedRepositoryId() {
      this.folderElements = [];
      this.fileElements = [];
      if (this.getSelectedRepositoryId) {
        this.selectedElement = this.getRepositories[this.getSelectedRepositoryId];
      }
    },
    progress(value) {
      if (value === 100) {
        this.filesToUpload = [];
        this.dragging = false;
        this.individualProgress = {};
        this.progress = 0;
      }
    },
    selectedElement() {
      if (this.selectedElement.propietarioId === this.companyId) {
        const activo = 1;
        this.userPermissions.read = activo;
        this.userPermissions.write = activo;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .view-panel{
    height: 33vh;
  }
  .view-panel-full {
    height: 70vh;
  }
  .view-table{
    height: 28vh;
    margin-top: 0.5rem !important;
  }
  .drop-icon-holder{
    margin-top:50px;
    margin-left: 50%;
    width: 50px;
    left: -25px;
    position: relative;
  }
  .drop-icon{
    font-size:50px;
    color: #ccc;
  }
  .drag{
    border: dashed 2px #ddd;
    background-color: #eee !important;
  }
  .drag .help{
    text-align: center;
    margin-top:30px;
    color:#1e1e1e;
  }
  .progress-content{
    display: inline-block;
  }
  .progress-content:first-child{
    vertical-align: sub;
  }
  .progress-wrapper{
    margin-top:50px;
    text-align: center;
  }
  .fb-bg-primary{
    background-color: rgb(var(--vs-primary));
  }
  .toggle{
    height: 20vh !important;
    overflow: hidden;
  }
  .separator{
    display: inline-block;
    width:20px;
  }
  #folder-elements{
    /* no eliminar! es por propositos de manejo de UI */
  }

</style>
